<template>
  <v-card
    class="pa-4 proof-item"
    style="background-color: transparent"
    outlined
    elevation="2"
  >
    <div class="proof-item__row">
      <div class="proof-item__main">
        <div class="mr-2 proof-item__icon">
          <v-icon
            style="background-color: #d32f2f"
            class="pa-2 rounded-lg"
            color="white"
            >{{ icon }}</v-icon
          >
        </div>
        <div class="proof-item__content">
          <span
            :class="{ 'file-link': Boolean(resolvedFileUrl) }"
            class="blue--text text--darken-2 font-weight-medium text-subtitle-1 text-md-h6 short-text"
            @click="openFile"
          >
            {{ label }} {{ filename }}
          </span>
          <span class="grey--text text--darken-1 short-text"
            >Subido {{ createdTime | formatDateShort }}</span
          >
        </div>
      </div>
      <div v-if="shouldShowAmount" class="proof-item__amount">
        <span class="text-subtitle-1 text-md-h6 grey--text text--darken-1">
          $ {{ amount }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
import { baseApiUrl } from "../environment/values";

export default {
  name: "ProofItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: "proof",
      validator: (value) => ["proof", "invoice"].includes(value),
    },
    showAmount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filename() {
      return this.item.filename;
    },
    file() {
      const value = this.item.file || this.item.archivo_factura || null;
      if (!value) return null;
      if (typeof value === "object" && value.url) return value.url;
      return String(value);
    },
    createdTime() {
      return this.item.proof_created_time || this.item.created_time || null;
    },
    amount() {
      return this.item.amount || this.item.monto_factura || null;
    },
    shouldShowAmount() {
      return this.showAmount && Boolean(this.amount);
    },
    icon() {
      return this.variant === "invoice" ? "image" : "description";
    },
    label() {
      return "Comprobante";
    },
    resolvedFileUrl() {
      if (!this.file) return null;

      let url = this.file.trim();
      if (!url) return null;

      if (/^https?:\/\//i.test(url)) {
        return url;
      }

      try {
        const origin = new URL(baseApiUrl).origin;
        const path = url.startsWith("/")
          ? url
          : `/media/${url.replace(/^media\//, "")}`;
        url = `${origin}${path}`;
      } catch (_) {
        return null;
      }

      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const token = user?.stsTokenManager?.accessToken;

        if (token) {
          const separator = url.includes("?") ? "&" : "?";
          url = `${url}${separator}token=${encodeURIComponent(token)}`;
        }
      } catch (_) {
        // keep url without token
      }

      return url;
    },
  },
  methods: {
    openFile() {
      if (!this.resolvedFileUrl) return;
      window.open(this.resolvedFileUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.proof-item__row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  min-width: 0;
}

.proof-item__main {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

.proof-item__icon {
  flex: 0 0 auto;
}

.proof-item__content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.proof-item__amount {
  flex: 0 0 auto;
  max-width: 40%;
  text-align: right;
  white-space: nowrap;
}

.short-text {
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-link {
  cursor: pointer;
}
</style>
